import type {CardDefinition} from './types';

// Explicit original-card effects, including original wording that differs from later catalogs.
export const expandedCardData:Array<Omit<CardDefinition,'id'|'image'|'text'>> = [
  {
    "number": 1,
    "name": "Orange Standing Fist Punch",
    "type": "Physical Combat",
    "style": "Orange",
    "originalText": "Physical Attack. Raise card user's anger level 1.",
    "effect": "attack",
    "attack": "physical",
    "damage": 0,
    "anger": 1
  },
  {
    "number": 3,
    "name": "Orange Two Knuckle Punch",
    "type": "Physical Combat",
    "style": "Orange",
    "originalText": "Physical Attack doing +1 stage of damage if successful. Raise card user's anger level 1.",
    "effect": "attack",
    "attack": "physical",
    "damage": 1,
    "anger": 1
  },
  {
    "number": 4,
    "name": "Orange Leg Sweep",
    "type": "Physical Combat",
    "style": "Orange",
    "originalText": "Physical Attack. Raise card user's anger level 1.",
    "effect": "attack",
    "attack": "physical",
    "damage": 0,
    "anger": 1
  },
  {
    "number": 5,
    "name": "Orange Arm Bar",
    "type": "Physical Combat",
    "style": "Orange",
    "originalText": "Physical Attack doing +3 stages of damage if succesful. Raise card user's anger level 1.",
    "effect": "attack",
    "attack": "physical",
    "damage": 3,
    "anger": 1
  },
  {
    "number": 6,
    "name": "Red Lunge Punch",
    "type": "Physical Combat",
    "style": "Red",
    "originalText": "Physical Attack. Raise card user's anger level 1.",
    "effect": "attack",
    "attack": "physical",
    "damage": 0,
    "anger": 1
  },
  {
    "number": 8,
    "name": "Red Knife Hand",
    "type": "Physical Combat",
    "style": "Red",
    "originalText": "Physical Attack doing +3 stages of damage if successful. Raise card user's anger level 1.",
    "effect": "attack",
    "attack": "physical",
    "damage": 3,
    "anger": 1
  },
  {
    "number": 9,
    "name": "Red Palm Heel Strike",
    "type": "Physical Combat",
    "style": "Red",
    "originalText": "Physical Attack doing +3 stages of damage if successful. Raise card user's anger level 1.",
    "effect": "attack",
    "attack": "physical",
    "damage": 3,
    "anger": 1
  },
  {
    "number": 10,
    "name": "Red Elbow Strike",
    "type": "Physical Combat",
    "style": "Red",
    "originalText": "Physical attack. Raise card user's anger level 1.",
    "effect": "attack",
    "attack": "physical",
    "damage": 0,
    "anger": 1
  },
  {
    "number": 11,
    "name": "Blue Forward Foot Sweep",
    "type": "Physical Combat",
    "style": "Blue",
    "originalText": "Physical Attack doing +4 stages of damage. If successful, this attack stops any energy attack from an opponent in the next phase. Lower foe's anger level 1.",
    "effect": "attack-next-energy-block",
    "attack": "physical",
    "damage": 4,
    "lowerAnger": 1
  },
  {
    "number": 12,
    "name": "Blue Hip Spring Throw",
    "type": "Physical Combat",
    "style": "Blue",
    "originalText": "Physical Attack doing +2 stages of damage if successful. Stops a foe's physical attack on their next round. Lower foe's anger by 1.",
    "effect": "attack-next-physical-block",
    "attack": "physical",
    "damage": 2,
    "lowerAnger": 1
  },
  {
    "number": 13,
    "name": "Blue Round Throw",
    "type": "Physical Combat",
    "style": "Blue",
    "originalText": "Physical Attack doing +5 stages of damage if successful or stops an energy attack. Lower foe's anger level by 1.",
    "effect": "attack",
    "attack": "physical",
    "damage": 5,
    "defense": "energy",
    "lowerAnger": 1
  },
  {
    "number": 17,
    "name": "Hidden Power Level",
    "type": "Physical Combat",
    "style": "Colorless",
    "originalText": "Physical attack. Before physical damage is assessed, change the power stage to the personality's maximum. They've been hiding their true level for just this attack.",
    "effect": "full-power-attack",
    "attack": "physical",
    "damage": 0
  },
  {
    "number": 18,
    "name": "Saiyan Arm Throw",
    "type": "Physical Combat",
    "style": "Saiyan",
    "originalText": "Villains, Goku, and Gohan only. Physical attack, plus it stops a single named foe from making a physical attack on his next phase.",
    "effect": "forbid-next-physical",
    "attack": "physical",
    "damage": 0,
    "restriction": "saiyan"
  },
  {
    "number": 19,
    "name": "Saiyan Full Spin Kick",
    "type": "Physical Combat",
    "style": "Saiyan",
    "originalText": "Villains, Goku, and Gohan only. Physical attack, plus it stops a single named foe from making an energy attack on his next phase.",
    "effect": "forbid-next-energy",
    "attack": "physical",
    "damage": 0,
    "restriction": "saiyan"
  },
  {
    "number": 21,
    "name": "Saiyan Neck Hold",
    "type": "Physical Combat",
    "style": "Saiyan",
    "originalText": "Villains, Goku, and Gohan only. Physical attack, plus it stops a single named foe from making a physical attack on his next phase. It costs 2 power stages to perform.",
    "effect": "forbid-next-physical",
    "attack": "physical",
    "damage": 0,
    "cost": 2,
    "restriction": "saiyan"
  },
  {
    "number": 23,
    "name": "Burning Rage!",
    "type": "Non-Combat",
    "style": "Colorless",
    "originalText": "Increase your anger level by 2. Take the bottom 2 cards from your discard pile and place them at the bottom of your life deck. Discard this card from the game after use.",
    "effect": "anger-bottom-recovery",
    "anger": 2,
    "banish": true
  },
  {
    "number": 24,
    "name": "Goku's Surprise Attack",
    "type": "Physical Combat",
    "style": "Named",
    "originalText": "Physical attack striking out for 5 stages of physical damage on a selected foe.",
    "effect": "attack",
    "attack": "physical",
    "damage": 0,
    "fixedPhysical": 5
  },
  {
    "number": 25,
    "name": "Goku's Physical Attack",
    "type": "Physical Combat",
    "style": "Named",
    "originalText": "Physical attack, plus draw the bottom card from the discard pile into your hand. If used by Goku, it stays on the table to be used one more time in this combat.",
    "effect": "goku-reusable-attack",
    "attack": "physical",
    "damage": 0
  },
  {
    "number": 26,
    "name": "Gohan's Physical Attack",
    "type": "Physical Combat",
    "style": "Named",
    "originalText": "Physical attack. Gohan gains 1 anger level. Increases Gohan's power rating by 5 stages.",
    "effect": "gohan-physical",
    "attack": "physical",
    "damage": 0
  },
  {
    "number": 27,
    "name": "Tien's Physical Attack",
    "type": "Physical Combat",
    "style": "Named",
    "originalText": "Physical attack doing 5 life card draws if succesful.",
    "effect": "physical-life",
    "attack": "physical",
    "damage": 5
  },
  {
    "number": 28,
    "name": "Vegeta's Physical Stance",
    "type": "Physical Combat",
    "style": "Named",
    "originalText": "No physical attacks will work against Vegeta this combat. Remove from game after use.",
    "effect": "vegeta-physical-stance",
    "defense": "physical",
    "banish": true
  },
  {
    "number": 29,
    "name": "Yajirobe's Physical Attack",
    "type": "Physical Combat",
    "style": "Named",
    "originalText": "Physical attack doing 2 draws from the life deck if not stopped. Remove from game after use.",
    "effect": "physical-life",
    "attack": "physical",
    "damage": 2,
    "banish": true
  },
  {
    "number": 30,
    "name": "Fall 7 times, get up 8 times",
    "type": "Non-Combat",
    "style": "Colorless",
    "originalText": "The first successful physical attack on you is stopped. Discard this card from the game after use.",
    "effect": "first-physical-shield",
    "banish": true
  },
  {
    "number": 31,
    "name": "Fortify Your Spirit",
    "type": "Non-Combat",
    "style": "Colorless",
    "originalText": "The first successful energy attack on you is stopped. Discard this card from the game after use.",
    "effect": "first-energy-shield",
    "banish": true
  },
  {
    "number": 32,
    "name": "The Untroubled Mind is Focused",
    "type": "Non-Combat",
    "style": "Colorless",
    "originalText": "Remove someone else's drill card or ally from the game. Discard this card from the game after use.",
    "effect": "remove-drill-ally",
    "banish": true
  },
  {
    "number": 33,
    "name": "It's the Little Things That Matter",
    "type": "Non-Combat",
    "style": "Colorless",
    "originalText": "Stop 1 successful energy or physical life card draw from happening. Discard this card from the game after use.",
    "effect": "one-life-shield",
    "banish": true
  },
  {
    "number": 34,
    "name": "Straining Off-Balancing Move",
    "type": "Physical Combat",
    "style": "Colorless",
    "originalText": "Physical attack forcing the defender to lose 1 life card and the attacker 3 stages of power. Limit 1 per deck.",
    "effect": "physical-life",
    "attack": "physical",
    "damage": 1,
    "cost": 3,
    "printedLimit": 1
  },
  {
    "number": 35,
    "name": "Straining, Penetrating Attack Move",
    "type": "Physical Combat",
    "style": "Colorless",
    "originalText": "Physical attack forcing the defender to lose 3 life cards and the attacker 3 stages of power. Limit 1 per deck.",
    "effect": "physical-life",
    "attack": "physical",
    "damage": 3,
    "cost": 3,
    "printedLimit": 1
  },
  {
    "number": 36,
    "name": "Straining Fake Left Move",
    "type": "Energy Combat",
    "style": "Colorless",
    "originalText": "Defensive move preventing up to 3 energy life   cards from being discarded and draining the user 4 stages.",
    "effect": "energy-reduction",
    "defense": "energy",
    "damage": 3,
    "cost": 4
  },
  {
    "number": 37,
    "name": "Straining Tripping Move",
    "type": "Physical Combat",
    "style": "Colorless",
    "originalText": "Physical attack forcing the defender to lose 2 life cards and the attacker 4 stages of power. Limit 1 per deck.",
    "effect": "physical-life",
    "attack": "physical",
    "damage": 2,
    "cost": 4,
    "printedLimit": 1
  },
  {
    "number": 38,
    "name": "Straining Arm Drag Move",
    "type": "Physical Combat",
    "style": "Colorless",
    "originalText": "Physical attack forcing the defender to lose 1 life card and the attack is over for the attacker.",
    "effect": "final-physical-life",
    "attack": "physical",
    "damage": 1
  },
  {
    "number": 39,
    "name": "Straining Ankle Smash Move",
    "type": "Energy Combat",
    "style": "Colorless",
    "originalText": "Play this card right after the attacker plays a card and pays their energy costs. The defender does 4 stages of power drain on the attacker, no matter what he is doing to the defender.",
    "effect": "reactive-power-drain",
    "defense": "both"
  },
  {
    "number": 40,
    "name": "Straining Energy Defense Move",
    "type": "Energy Combat",
    "style": "Colorless",
    "originalText": "Stops an energy attack, but you have to discard another card to use this one.",
    "effect": "discard-energy-block",
    "defense": "energy"
  },
  {
    "number": 41,
    "name": "Straining Head Lock Move",
    "type": "Physical Combat",
    "style": "Colorless",
    "originalText": "Stops a physical attack, but you have to discard another card to use this one.",
    "effect": "discard-physical-block",
    "defense": "physical"
  },
  {
    "number": 42,
    "name": "Straining Rolling Escape Move",
    "type": "Energy Combat",
    "style": "Colorless",
    "originalText": "Stops an energy attack, but the user cannot make any attacks for the rest of this combat.",
    "effect": "energy-block-lock",
    "defense": "energy"
  },
  {
    "number": 43,
    "name": "Senzu Bean",
    "type": "Non-Combat",
    "style": "Colorless",
    "originalText": "This card is played and then is taken out of the game. It moves the power stage of the main personality to the highest rating.",
    "effect": "immediate-full-power",
    "banish": true
  },
  {
    "number": 44,
    "name": "Goku Body Throw!",
    "type": "Physical Combat",
    "style": "Named",
    "originalText": "Physical attack doing 1 life card of damage.",
    "effect": "physical-life",
    "attack": "physical",
    "damage": 1
  },
  {
    "number": 45,
    "name": "Saiyan City Destruction",
    "type": "Non-Combat",
    "style": "Saiyan",
    "originalText": "Villains only. Skip your next Combat step. Place the top 2 cards from your discard pile on the bottom of your Life Deck. Remove from the game after use.",
    "effect": "city-destruction",
    "restriction": "villain",
    "banish": true
  },
  {
    "number": 46,
    "name": "Goku Anger Attack",
    "type": "Physical Combat",
    "style": "Named",
    "originalText": "This physical attack does double the normal damage if successful.",
    "effect": "physical-double",
    "attack": "physical",
    "damage": 0
  },
  {
    "number": 48,
    "name": "Goku's Touch",
    "type": "Non-Combat",
    "style": "Named",
    "originalText": "After a successful physical attack, take a foe's Dragon Ball. Discard this card after use.",
    "effect": "physical-capture-setup"
  },
  {
    "number": 50,
    "name": "Orange Shoulder Throw",
    "type": "Physical Combat",
    "style": "Orange",
    "originalText": "Stops an opponent's physical attack this round. Raise card user's anger level 1.",
    "effect": "defense",
    "defense": "physical",
    "anger": 1
  },
  {
    "number": 53,
    "name": "Orange Holding After Takedown",
    "type": "Physical Combat",
    "style": "Orange",
    "originalText": "Stops opponent's physical attack this round. Foe's anger level decreases by 1.",
    "effect": "defense",
    "defense": "physical",
    "lowerAnger": 1
  },
  {
    "number": 55,
    "name": "Red Front Kick",
    "type": "Physical Combat",
    "style": "Red",
    "originalText": "Physical Attack doing +1 stage of damage if successful. Raise card user's anger level 1.",
    "effect": "attack",
    "attack": "physical",
    "damage": 1,
    "anger": 1
  },
  {
    "number": 56,
    "name": "Red Side Kick",
    "type": "Energy Combat",
    "style": "Red",
    "originalText": "Stop foe's energy attack this round.",
    "effect": "defense",
    "defense": "energy"
  },
  {
    "number": 57,
    "name": "Red Round Kick",
    "type": "Physical Combat",
    "style": "Red",
    "originalText": "Physical Attack doing +3 stages of damage if successful. Foe's Anger level decreases by 1.",
    "effect": "attack",
    "attack": "physical",
    "damage": 3,
    "lowerAnger": 1
  },
  {
    "number": 58,
    "name": "Red Back Kick",
    "type": "Physical Combat",
    "style": "Red",
    "originalText": "Physical Attack doing +3 stages of damage if successful. Stops all energy attacks for the rest of this combat. Foe's anger level decreases by 1.",
    "effect": "attack-energy-shield",
    "attack": "physical",
    "damage": 3,
    "lowerAnger": 1
  },
  {
    "number": 59,
    "name": "Blue Big Outside Drop",
    "type": "Physical Combat",
    "style": "Blue",
    "originalText": "Stops a physical attack. Raise card user's anger level 1.",
    "effect": "defense",
    "defense": "physical",
    "anger": 1
  },
  {
    "number": 60,
    "name": "Blue One-Arm Shoulder Throw",
    "type": "Physical Combat",
    "style": "Blue",
    "originalText": "Stops the foe's physical attack. Lower foe's anger level 1.",
    "effect": "defense",
    "defense": "physical",
    "lowerAnger": 1
  },
  {
    "number": 61,
    "name": "Blue Body Drop Throw",
    "type": "Physical Combat",
    "style": "Blue",
    "originalText": "Stops a physical attack. Lower foe's anger level by 1.",
    "effect": "defense",
    "defense": "physical",
    "lowerAnger": 1
  },
  {
    "number": 62,
    "name": "Blue Inner Leg Throw",
    "type": "Physical Combat",
    "style": "Blue",
    "originalText": "Stops a physical attack. Lower foe's anger level by 1.",
    "effect": "defense",
    "defense": "physical",
    "lowerAnger": 1
  },
  {
    "number": 64,
    "name": "Blue Ground Holding",
    "type": "Physical Combat",
    "style": "Blue",
    "originalText": "Stops a physical attack. Lowers foe's anger level by 1.",
    "effect": "defense",
    "defense": "physical",
    "lowerAnger": 1
  },
  {
    "number": 65,
    "name": "Black Fore Fist Punch",
    "type": "Energy Combat",
    "style": "Black",
    "originalText": "Energy Attack doing 6 life card draws of damage and lowering foe's power 3 stages or to 0, which ever happens first.",
    "effect": "energy-power-drain",
    "attack": "energy",
    "damage": 6,
    "cost": 2
  },
  {
    "number": 66,
    "name": "Black Knife Hand Strike",
    "type": "Energy Combat",
    "style": "Black",
    "originalText": "Energy Attack doing 4 life card draws of damage or stopping any energy attack.",
    "effect": "attack",
    "attack": "energy",
    "damage": 4,
    "cost": 2,
    "defense": "energy"
  },
  {
    "number": 67,
    "name": "Black Elbow Strike",
    "type": "Physical Combat",
    "style": "Black",
    "originalText": "Stops a foe's physical attack. Raise card user's anger level 1.",
    "effect": "defense",
    "defense": "physical",
    "anger": 1
  },
  {
    "number": 68,
    "name": "Black Front Kick",
    "type": "Energy Combat",
    "style": "Black",
    "originalText": "Energy Attack doing 5 life card draws in damage and costing 4 stages of power to perform. Raise card user's anger level 2.",
    "effect": "attack",
    "attack": "energy",
    "damage": 5,
    "cost": 4,
    "anger": 2
  },
  {
    "number": 69,
    "name": "Black Side Kick",
    "type": "Physical Combat",
    "style": "Black",
    "originalText": "Stops a foe's physical attack. Raise card user's anger level 2.",
    "effect": "defense",
    "defense": "physical",
    "anger": 2
  },
  {
    "number": 70,
    "name": "Black Turning Kick",
    "type": "Energy Combat",
    "style": "Black",
    "originalText": "Energy Attack doing 5 life card draws of damage or stops a physical attack. Raise card user's anger level 1.",
    "effect": "attack",
    "attack": "energy",
    "damage": 5,
    "cost": 2,
    "defense": "physical",
    "anger": 1
  },
  {
    "number": 71,
    "name": "Black Back Kick",
    "type": "Energy Combat",
    "style": "Black",
    "originalText": "Energy Attack doing 6 life card draws of damage and costing 5 power stages to perform. Raise card user's anger level 1.",
    "effect": "attack",
    "attack": "energy",
    "damage": 6,
    "cost": 5,
    "anger": 1
  },
  {
    "number": 73,
    "name": "Black Rear Spin Kick",
    "type": "Energy Combat",
    "style": "Black",
    "originalText": "Stops a foe's energy attack. Raise card user's anger level 1.",
    "effect": "defense",
    "defense": "energy",
    "anger": 1
  },
  {
    "number": 79,
    "name": "King Kai Training",
    "type": "Non-Combat",
    "style": "Named",
    "originalText": "Heroes only. 2 cards of your choice are placed at the bottom of your life deck.",
    "effect": "saiyan-training",
    "restriction": "hero"
  },
  {
    "number": 81,
    "name": "Saiyan Armor",
    "type": "Non-Combat",
    "style": "Saiyan",
    "originalText": "Prevents 1 life card discard from any successful energy attack that would have normally forced 1 or more discards. Limit one per deck.",
    "effect": "energy-reduction-passive",
    "damage": 1,
    "printedLimit": 1
  },
  {
    "number": 82,
    "name": "Tien (Lvl 1)",
    "type": "Hero",
    "style": "",
    "level": 1,
    "pur": 1,
    "originalText": "Multi-Form allows two physical attacks, one after another, or a defense against a physical attack preventing 4 stages of successful damage.",
    "effect": "multiform",
    "stages": [
      0,
      100,
      200,
      300,
      400,
      500,
      600,
      700,
      800,
      900,
      1000
    ],
    "character": "tien"
  },
  {
    "number": 83,
    "name": "Tien (Lvl 2)",
    "type": "Hero",
    "style": "",
    "level": 2,
    "pur": 2,
    "originalText": "Solar Flare Energy Attack: If it is not blocked it stuns the foe, so he must skip his next opportunity to attack back.",
    "effect": "solar-flare",
    "attack": "energy",
    "damage": 4,
    "cost": 2,
    "stages": [
      0,
      500,
      600,
      700,
      800,
      900,
      1000,
      1100,
      1200,
      1300,
      1400
    ],
    "character": "tien"
  },
  {
    "number": 84,
    "name": "Yamcha (Lvl 1)",
    "type": "Hero",
    "style": "",
    "level": 1,
    "pur": 1,
    "originalText": "Spirit Ball Energy Attack does 2 life card draws of damage.",
    "effect": "personality",
    "attack": "energy",
    "damage": 2,
    "cost": 2,
    "stages": [
      0,
      100,
      200,
      300,
      400,
      500,
      600,
      700,
      800,
      900,
      1000
    ],
    "character": "yamcha"
  },
  {
    "number": 85,
    "name": "Yamcha (Lvl 2)",
    "type": "Hero",
    "style": "",
    "level": 2,
    "pur": 2,
    "originalText": "Solar Flare Energy Attack: If it is not blocked it stuns the foe, so he must skip his next opportunity to attack back.",
    "effect": "solar-flare",
    "attack": "energy",
    "damage": 4,
    "cost": 2,
    "stages": [
      0,
      500,
      600,
      700,
      800,
      900,
      1000,
      1100,
      1200,
      1300,
      1400
    ],
    "character": "yamcha"
  },
  {
    "number": 86,
    "name": "Chi-Chi (Lvl 1)",
    "type": "Hero",
    "style": "",
    "level": 1,
    "pur": 1,
    "originalText": "Mother's Defense: Once per combat, this can block a single physical attack directed at Gohan or Goku so they are not hurt.",
    "effect": "chi-chi-defense",
    "stages": [
      0,
      100,
      200,
      300,
      400,
      500,
      600,
      700,
      800,
      900,
      1000
    ],
    "character": "chi-chi"
  },
  {
    "number": 87,
    "name": "Bulma (Lvl 1)",
    "type": "Hero",
    "style": "",
    "level": 1,
    "pur": 1,
    "originalText": "Scientific Defense: Reduces the damage done by an energy attack by 2 life card draws.",
    "effect": "energy-reduce-two",
    "stages": [
      0,
      100,
      200,
      300,
      400,
      500,
      600,
      700,
      800,
      900,
      1000
    ],
    "character": "bulma"
  },
  {
    "number": 88,
    "name": "King Kai Uniform",
    "type": "Non-Combat",
    "style": "Named",
    "originalText": "The uniform prevents 1 life card discard from any successful physical attack that would have normally forced 1 or more discards. Limit one per deck.",
    "effect": "physical-life-reduction-passive",
    "damage": 1,
    "printedLimit": 1
  },
  {
    "number": 89,
    "name": "Dream Chamber Training",
    "type": "Non-Combat",
    "style": "Colorless",
    "originalText": "Heroes only. 2 discards of the user's choice are placed at the bottom of your life deck. Discard from the game after use.",
    "effect": "saiyan-training",
    "restriction": "hero",
    "banish": true
  },
  {
    "number": 90,
    "name": "Mother's Touch",
    "type": "Combat",
    "style": "Colorless",
    "originalText": "Stops a physical or energy attack. Remove from the game after use.",
    "effect": "defense",
    "defense": "both",
    "banish": true
  },
  {
    "number": 91,
    "name": "Saiyan Energy Throw",
    "type": "Energy Combat",
    "style": "Saiyan",
    "originalText": "Villains, Goku, and Gohan only. Creates an energy attack doing 7 life card draws at a cost of 4 stages of power drain. Discard from the game after use.",
    "effect": "attack",
    "attack": "energy",
    "damage": 7,
    "cost": 4,
    "banish": true,
    "restriction": "saiyan"
  },
  {
    "number": 94,
    "name": "Saiyan Energy Blast",
    "type": "Energy Combat",
    "style": "Saiyan",
    "originalText": "Saiyan Heritage only. Energy attack, plus it stops a single named foe from making a physical attack on his next phase at a cost of 3 stages of power drain.",
    "effect": "forbid-next-physical",
    "attack": "energy",
    "damage": 4,
    "cost": 3,
    "restriction": "saiyan"
  },
  {
    "number": 95,
    "name": "Saiyan Energy Aura",
    "type": "Energy Combat",
    "style": "Saiyan",
    "originalText": "Saiyan Heritage Only. Stops an energy attack and stops energy attacks in the next phase.",
    "effect": "block-next-energy",
    "defense": "energy",
    "restriction": "saiyan"
  },
  {
    "number": 96,
    "name": "Saiyan Sweeping Defense",
    "type": "Physical Combat",
    "style": "Saiyan",
    "originalText": "Saiyan Heritage only. Stops a physical attack and stops physical attacks in the next phase.",
    "effect": "block-next-physical",
    "defense": "physical",
    "restriction": "saiyan"
  },
  {
    "number": 97,
    "name": "Power Up More!",
    "type": "Non-Combat",
    "style": "Colorless",
    "originalText": "Powers up 6 stages for a personality, going no higher than maximum stage",
    "effect": "power-up-six"
  },
  {
    "number": 98,
    "name": "Power Up the Most!",
    "type": "Non-Combat",
    "style": "Colorless",
    "originalText": "Powers up to the personality's highest stage. Select 2 discarded cards and place them at the bottomof your life deck.",
    "effect": "power-up-full-recover"
  },
  {
    "number": 99,
    "name": "Blazing Anger!",
    "type": "Non-Combat",
    "style": "Colorless",
    "originalText": "Increase your anger level by 2. Take the top 2 cards from your discard pile and place them at the bottom of your life deck.",
    "effect": "anger-top-recovery",
    "anger": 2
  },
  {
    "number": 100,
    "name": "Vegeta's Suprise Defense",
    "type": "Combat",
    "style": "Named",
    "originalText": "Stop one physical or energy attack from doing damage. Discard this card from the game after one use.",
    "effect": "defense",
    "defense": "both",
    "banish": true
  },
  {
    "number": 101,
    "name": "Goku Honor Duel!",
    "type": "Non-Combat",
    "style": "Named",
    "originalText": "Goku uses the bottom 3 cards of the discard deck for the next combat instead of the cards from his life deck. If there are not enough cards, do not use this ability. Discard from the game after use.",
    "effect": "named-honor-duel",
    "banish": true
  },
  {
    "number": 102,
    "name": "Raditz Honor Duel!",
    "type": "Non-Combat",
    "style": "Named",
    "originalText": "Raditz uses the bottom 3 cards of the discard deck for the next combat instead of the cards from his life deck. If there are not enough cards, do not use this ability. Discard from the game after use.",
    "effect": "named-honor-duel",
    "banish": true
  },
  {
    "number": 103,
    "name": "Piccolo Honor Duel!",
    "type": "Non-Combat",
    "style": "Named",
    "originalText": "Piccolo uses the bottom 3 cards of the discard deck for the next combat instead of the cards from his life deck. If there are not enough cards, do not use this ability. Discard from the game after use.",
    "effect": "named-honor-duel",
    "banish": true
  },
  {
    "number": 105,
    "name": "Chiaotzu (Lvl 2)",
    "type": "Hero",
    "style": "",
    "level": 2,
    "pur": 2,
    "originalText": "Blast Energy Attack does 6 life cards of damage and removes Chiaotzu from the game.",
    "effect": "sacrifice-personality-attack",
    "attack": "energy",
    "damage": 6,
    "cost": 2,
    "stages": [
      0,
      500,
      600,
      700,
      800,
      900,
      1000,
      1100,
      1200,
      1300,
      1400
    ],
    "character": "chiaotzu"
  },
  {
    "number": 106,
    "name": "Yajirobe (Lvl 1)",
    "type": "Hero",
    "style": "",
    "level": 1,
    "pur": 1,
    "originalText": "Physical Attack.",
    "effect": "personality",
    "attack": "physical",
    "damage": 0,
    "stages": [
      0,
      100,
      200,
      300,
      400,
      500,
      600,
      700,
      800,
      900,
      1000
    ],
    "character": "yajirobe"
  },
  {
    "number": 107,
    "name": "Yajirobe (Lvl 2)",
    "type": "Hero",
    "style": "",
    "level": 2,
    "pur": 2,
    "originalText": "Energy attack needs 3 power stages to perform.",
    "effect": "personality",
    "attack": "energy",
    "damage": 4,
    "cost": 3,
    "stages": [
      0,
      500,
      600,
      700,
      800,
      900,
      1000,
      1100,
      1200,
      1300,
      1400
    ],
    "character": "yajirobe"
  },
  {
    "number": 108,
    "name": "Goku's Energy Defense",
    "type": "Energy Combat",
    "style": "Named",
    "originalText": "Prevents 3 life cards from being discarded from a successful energy attack. If used by Goku, it stays on the table to be used one more time in this combat.",
    "effect": "goku-reusable-defense",
    "defense": "energy",
    "damage": 3
  },
  {
    "number": 111,
    "name": "Gohan's Energy Defense",
    "type": "Energy Combat",
    "style": "Named",
    "originalText": "Prevents an energy attack. Gains Gohan 1 anger level.",
    "effect": "gohan-defense",
    "defense": "energy"
  },
  {
    "number": 112,
    "name": "Krillin's Physical Defense",
    "type": "Combat",
    "style": "Named",
    "originalText": "When Krillin is forced to discard from his life deck, he may take that first card into his hand. If used by Krillin, this card stays on the table to be used one more time in this combat.",
    "effect": "krillin-defense",
    "defense": "both"
  },
  {
    "number": 113,
    "name": "Krillin's Energy Attack",
    "type": "Energy Combat",
    "style": "Named",
    "originalText": "Energy attack doing 2 draws from the life card deck if not stopped. If used by Krillin, this card stays on the table to be used one more time in this combat.",
    "effect": "reusable-attack",
    "attack": "energy",
    "damage": 2,
    "cost": 2
  },
  {
    "number": 114,
    "name": "Tien's Energy Defense",
    "type": "Energy Combat",
    "style": "Named",
    "originalText": "Prevents a foe's energy attack.",
    "effect": "defense",
    "defense": "energy"
  },
  {
    "number": 115,
    "name": "Yamcha's Energy Attack",
    "type": "Energy Combat",
    "style": "Named",
    "originalText": "Energy attack doing 2 life card draws of damage. Costs 3 power stages to perform.",
    "effect": "attack",
    "attack": "energy",
    "damage": 2,
    "cost": 3
  },
  {
    "number": 116,
    "name": "Yamcha's Physical Defense",
    "type": "Physical Combat",
    "style": "Named",
    "originalText": "Prevents 3 life cards from being taken in a successful physical attack.",
    "effect": "physical-life-reduction",
    "defense": "physical",
    "damage": 3
  },
  {
    "number": 117,
    "name": "Raditz Energy Wall",
    "type": "Combat",
    "style": "Named",
    "originalText": "Forces a Hero opponent in this combat to discard 1 life card from his deck. Discard this card from the game after use.",
    "effect": "hero-life-damage",
    "damage": 1,
    "banish": true
  },
  {
    "number": 118,
    "name": "Raditz Physical Defense",
    "type": "Combat",
    "style": "Named",
    "originalText": "Forces Hero opponent in this combat to take his anger level down 2. Discard this card from the game ater use.",
    "effect": "hero-anger-reduce",
    "damage": 2,
    "banish": true
  },
  {
    "number": 119,
    "name": "Vegeta's Energy Blast",
    "type": "Combat",
    "style": "Named",
    "originalText": "A Saiyan power-up allowing this Saiyan to power up to full at the beginning of this combat round. Discard this card from the game after use.",
    "effect": "first-saiyan-full-power",
    "restriction": "saiyan",
    "banish": true
  },
  {
    "number": 120,
    "name": "Nappa's Energy Aura",
    "type": "Energy Combat",
    "style": "Named",
    "originalText": "No energy attacks will work against Nappa this combat. Remove from game after use.",
    "effect": "nappa-energy-aura",
    "defense": "energy",
    "banish": true
  },
  {
    "number": 121,
    "name": "Nappa's Physical Resistance",
    "type": "Physical Combat",
    "style": "Named",
    "originalText": "No physical attacks will work against Nappa this combat. Remove from game after use.",
    "effect": "nappa-physical-resistance",
    "defense": "physical",
    "banish": true
  },
  {
    "number": 122,
    "name": "Yajirobe's Energy Attack",
    "type": "Energy Combat",
    "style": "Named",
    "originalText": "Energy attack forcing 1 draw from the life deck if not stopped. Remove from game after use.",
    "effect": "attack",
    "attack": "energy",
    "damage": 1,
    "cost": 2,
    "banish": true
  },
  {
    "number": 123,
    "name": "Chiaotzu's Energy Manipulation",
    "type": "Energy Combat",
    "style": "Named",
    "originalText": "Energy attack forcing 3 draws from the life deck. Remove from the game after use. Card limited to 1 per deck.",
    "effect": "attack",
    "attack": "energy",
    "damage": 3,
    "cost": 2,
    "banish": true,
    "printedLimit": 1
  },
  {
    "number": 124,
    "name": "Red Penetrating Defense Drill",
    "type": "Non-Combat",
    "style": "Red",
    "originalText": "Stops 2 stages of power from being drained by any physical attack.",
    "effect": "physical-reduction-drill",
    "damage": 2
  },
  {
    "number": 125,
    "name": "Blue Off-Balancing Opponent Drill",
    "type": "Non-Combat",
    "style": "Blue",
    "originalText": "Creates +1 stage damage for each successful physical attack made by this personality.",
    "effect": "physical-bonus-drill",
    "damage": 1
  },
  {
    "number": 126,
    "name": "Orange Lifting Drill",
    "type": "Non-Combat",
    "style": "Orange",
    "originalText": "Sweeps everyone else's drills from the playing table, but not this personality's drills. Limit 1 per deck.",
    "effect": "sweep-drills",
    "printedLimit": 1
  },
  {
    "number": 127,
    "name": "Black Takedown Drill",
    "type": "Non-Combat",
    "style": "Black",
    "originalText": "Allows the attacker to draw a card into his hand in every phase he makes an attack.",
    "effect": "attack-draw-drill"
  },
  {
    "number": 128,
    "name": "Red Knee Pick Drill",
    "type": "Non-Combat",
    "style": "Red",
    "originalText": "Allows the attacker to draw an extra card at the beginning of a combat.",
    "effect": "attacker-draw-drill"
  },
  {
    "number": 129,
    "name": "Blue Deceiving Drill",
    "type": "Non-Combat",
    "style": "Blue",
    "originalText": "At the beginning of every combat where the personality is the defender, raise the power level of this card owner 3 stages up to the maximum.",
    "effect": "defender-power-drill"
  },
  {
    "number": 130,
    "name": "Orange Tripping Drill",
    "type": "Non-Combat",
    "style": "Orange",
    "originalText": "Prevents 1 life card from being taken away by any successful energy attack on this card's owner.",
    "effect": "energy-reduction-passive",
    "damage": 1
  },
  {
    "number": 131,
    "name": "Black Bear Hug Drill",
    "type": "Non-Combat",
    "style": "Black",
    "originalText": "Creates a +2 stage drain with each successful physical attack made by this card's attacker.",
    "effect": "physical-bonus-drill",
    "damage": 2
  },
  {
    "number": 132,
    "name": "Red Rolling Drill",
    "type": "Non-Combat",
    "style": "Red",
    "originalText": "Prevents 1 life card draw from a successful energy attack.",
    "effect": "energy-reduction-passive",
    "damage": 1
  },
  {
    "number": 133,
    "name": "Blue Reversal Drill",
    "type": "Non-Combat",
    "style": "Blue",
    "originalText": "Do the exact same physical attack you defended against during your defending round of combat, once per combat.",
    "effect": "physical-copy-drill"
  },
  {
    "number": 134,
    "name": "Orange Off-Balancing Drill",
    "type": "Non-Combat",
    "style": "Orange",
    "originalText": "Stop the first physical attack made on you in a combat.",
    "effect": "combat-first-physical-block"
  },
  {
    "number": 135,
    "name": "Black Arm Bar Drill",
    "type": "Non-Combat",
    "style": "Black",
    "originalText": "Stops the first energy attack made on you in a combat. Can't be used with any Orange drills in play anywhere on the table.",
    "effect": "combat-first-energy-block"
  },
  {
    "number": 136,
    "name": "Black Free-Style Drill",
    "type": "Non-Combat",
    "style": "Black",
    "originalText": "Draw a card from the bottom of your discard pile after receiving a successful energy attack. Cannot be used with any other Black Drill cards in play anywhere on the table.",
    "effect": "energy-discard-draw"
  },
  {
    "number": 137,
    "name": "Orange Spontaneous Drill",
    "type": "Non-Combat",
    "style": "Orange",
    "originalText": "Draw a card from the bottom of your discard pile after suffering a successful physical attack.",
    "effect": "physical-discard-draw"
  },
  {
    "number": 138,
    "name": "Blue Cradle Drill",
    "type": "Non-Combat",
    "style": "Blue",
    "originalText": "For every life card you lose in combat, your foe loses 1 power stage, down to (0).",
    "effect": "life-reflect-stages"
  },
  {
    "number": 139,
    "name": "Red Wrist Control Drill",
    "type": "Non-Combat",
    "style": "Red",
    "originalText": "For every 3 stages of power you lose, your foe loses 1 power stage, down to (0).",
    "effect": "stages-reflect-stages"
  },
  {
    "number": 140,
    "name": "Red Reading Drill",
    "type": "Non-Combat",
    "style": "Red",
    "originalText": "Foreknowledge allows the personality to take 1 less life card discard, once for the entire set of combat rounds.",
    "effect": "combat-life-reduction"
  },
  {
    "number": 141,
    "name": "Blue Enemies Drill",
    "type": "Non-Combat",
    "style": "Blue",
    "originalText": "Allows the personality to defend well against physical attacks and prevents 1 life card discard per combat, if the foe has an ally.",
    "effect": "ally-combat-life-reduction"
  },
  {
    "number": 142,
    "name": "Orange Energy Drill",
    "type": "Non-Combat",
    "style": "Orange",
    "originalText": "Allows the defender to take 1 less life card discard from every energy attack. Cannot be used with other Orange Drills in play on the table.",
    "effect": "energy-reduction-passive",
    "damage": 1
  },
  {
    "number": 143,
    "name": "Black Physical Drill",
    "type": "Non-Combat",
    "style": "Black",
    "originalText": "Allows the defender to take 1 less life card discard from every physical attack. Can't be used with other Black drills in play on the table.",
    "effect": "physical-life-reduction-passive",
    "damage": 1
  },
  {
    "number": 144,
    "name": "Red Coordination Drill",
    "type": "Non-Combat",
    "style": "Red",
    "originalText": "Allows the defender to draw an extra card at the beginning of any combat if he desires.",
    "effect": "defender-draw-drill"
  },
  {
    "number": 146,
    "name": "Orange Body Shifting Drill",
    "type": "Non-Combat",
    "style": "Orange",
    "originalText": "Allows the attacker to pay 1 stage instead of 2 on any energy attack.",
    "effect": "energy-cost-drill"
  },
  {
    "number": 147,
    "name": "Black Striking Drill",
    "type": "Non-Combat",
    "style": "Black",
    "originalText": "Allows the attacker to do 2 extra stages of power damage with every successful physical attack.",
    "effect": "physical-bonus-drill",
    "damage": 2
  },
  {
    "number": 148,
    "name": "Red Pressure Point Drill",
    "type": "Non-Combat",
    "style": "Red",
    "originalText": "Allows the attacker to do 1 extra life card of damage with every successful energy attack. Cannot be used with other Red Drills in play on the table.",
    "effect": "energy-bonus-drill",
    "damage": 1
  },
  {
    "number": 149,
    "name": "Meditation Drill",
    "type": "Non-Combat",
    "style": "Colorless",
    "originalText": "Allows the player to shuffle their life deck or discards just before any announced combat.",
    "effect": "shuffle-drill"
  },
  {
    "number": 150,
    "name": "Blue Neck Restraint Drill",
    "type": "Non-Combat",
    "style": "Blue",
    "originalText": "Allows the attacker to inflict +3 stages of damage from any successful physical attack. Cannot be used with any other Blue drills in play on the table.",
    "effect": "physical-bonus-drill",
    "damage": 3
  },
  {
    "number": 151,
    "name": "Orange Joint Restraint Drill",
    "type": "Non-Combat",
    "style": "Orange",
    "originalText": "Allows the attacker to inflict +4 stages of damage from any successful physical attack.",
    "effect": "physical-bonus-drill",
    "damage": 4
  },
  {
    "number": 152,
    "name": "Black Defender Drill",
    "type": "Non-Combat",
    "style": "Black",
    "originalText": "Allows the defender to take 1 less life card draw from damage on any successful energy attack.",
    "effect": "energy-reduction-passive",
    "damage": 1
  },
  {
    "number": 153,
    "name": "Goku Energy Blast!",
    "type": "Energy Combat",
    "style": "Named",
    "originalText": "Energy defense stopping a foe's physical attack. Discard from the game after use.",
    "effect": "defense",
    "defense": "physical",
    "banish": true
  },
  {
    "number": 155,
    "name": "Piccolo Defense Drill",
    "type": "Non-Combat",
    "style": "Named",
    "originalText": "Prevents 1 life card from being discarded from a successful energy attack.",
    "effect": "energy-reduction-passive",
    "damage": 1
  },
  {
    "number": 156,
    "name": "Ally's Sacrifice",
    "type": "Combat",
    "style": "Colorless",
    "originalText": "All the damage you would have taken in this combat destroys one of your allies instead.",
    "effect": "ally-sacrifice"
  },
  {
    "number": 157,
    "name": "Eyes of the Dragon",
    "type": "Non-Combat",
    "style": "Colorless",
    "originalText": "After a successful energy attack, this card owner can pick a Dragon Ball out of his deck and capture a Dragon Ball from the damaged foe. Limit 1 per deck.",
    "effect": "eyes-of-dragon",
    "printedLimit": 1
  },
  {
    "number": 158,
    "name": "Goku (Lvl 1)",
    "type": "Hero",
    "style": "",
    "level": 1,
    "pur": 1,
    "originalText": "Kamehameha Energy: Attack does three life card draws and only costs one power stage to perform.",
    "effect": "personality",
    "attack": "energy",
    "damage": 3,
    "cost": 1,
    "stages": [
      0,
      500,
      600,
      700,
      800,
      900,
      1000,
      1100,
      1200,
      1300,
      1400
    ],
    "character": "goku"
  },
  {
    "number": 159,
    "name": "Goku (Lvl 2)",
    "type": "Hero",
    "style": "",
    "level": 2,
    "pur": 2,
    "originalText": "Kaio-Ken Power Level Booster: Physical attack draining 4 power stages no matter what Goku's power is. Do not consult table.",
    "effect": "personality",
    "attack": "physical",
    "fixedPhysical": 4,
    "damage": 0,
    "stages": [
      0,
      3200,
      3700,
      4200,
      4700,
      5200,
      5700,
      6200,
      6700,
      7200,
      7700
    ],
    "character": "goku"
  },
  {
    "number": 160,
    "name": "Goku (Lvl 3)",
    "type": "Hero",
    "style": "",
    "level": 3,
    "pur": 3,
    "originalText": "Prevent 2 life card draws form being discarded from a successful energy attack.",
    "effect": "energy-reduce-two",
    "stages": [
      0,
      8000,
      8500,
      9000,
      9500,
      10000,
      10500,
      11000,
      11500,
      12000,
      12500
    ],
    "character": "goku"
  },
  {
    "number": 164,
    "name": "Gohan (Lvl 1)",
    "type": "Hero",
    "style": "",
    "level": 1,
    "pur": 1,
    "originalText": "When defending and facing an energy attack, he can raise his anger level once per combat with this power.",
    "effect": "gohan-defending-anger",
    "stages": [
      0,
      100,
      200,
      300,
      400,
      500,
      600,
      700,
      800,
      900,
      1000
    ],
    "character": "gohan"
  },
  {
    "number": 165,
    "name": "Gohan (Lvl 2)",
    "type": "Hero",
    "style": "",
    "level": 2,
    "pur": 2,
    "originalText": "Once during the game, he can turn into Kong Gohan, inflicting 8 stages of physical damage in his first round of combat.",
    "effect": "kong-gohan",
    "attack": "physical",
    "fixedPhysical": 8,
    "damage": 0,
    "stages": [
      0,
      500,
      600,
      700,
      800,
      900,
      1000,
      1100,
      1200,
      1300,
      1400
    ],
    "character": "gohan"
  },
  {
    "number": 166,
    "name": "Gohan (Lvl 3)",
    "type": "Hero",
    "style": "",
    "level": 3,
    "pur": 3,
    "originalText": "Kamehameha Energy Attack does 3 life card draws and only costs 1 power stage to perform.",
    "effect": "personality",
    "attack": "energy",
    "damage": 3,
    "cost": 1,
    "stages": [
      0,
      1500,
      1700,
      1900,
      2100,
      2300,
      2500,
      2700,
      2900,
      3100,
      3200
    ],
    "character": "gohan"
  },
  {
    "number": 167,
    "name": "Krillin (Lvl 1)",
    "type": "Hero",
    "style": "",
    "level": 1,
    "pur": 1,
    "originalText": "Power Ball Energy Attack: Inflicts 2 life card draws of damage.",
    "effect": "personality",
    "attack": "energy",
    "damage": 2,
    "cost": 2,
    "stages": [
      0,
      100,
      200,
      300,
      400,
      500,
      600,
      700,
      800,
      900,
      1000
    ],
    "character": "krillin"
  },
  {
    "number": 168,
    "name": "Krillin (Lvl 2)",
    "type": "Hero",
    "style": "",
    "level": 2,
    "pur": 2,
    "originalText": "Destructo-Disk Energy Attack doing 3 life card draws of damage.",
    "effect": "personality",
    "attack": "energy",
    "damage": 3,
    "cost": 2,
    "stages": [
      0,
      500,
      600,
      700,
      800,
      900,
      1000,
      1100,
      1200,
      1300,
      1400
    ],
    "character": "krillin"
  },
  {
    "number": 169,
    "name": "Krillin (Lvl 3)",
    "type": "Hero",
    "style": "",
    "level": 3,
    "pur": 3,
    "originalText": "Take 1 card from the discard pile and place it at the bottom of your life deck.",
    "effect": "krillin-recovery",
    "stages": [
      0,
      1500,
      1700,
      1900,
      2100,
      2300,
      2500,
      2700,
      2900,
      3100,
      3200
    ],
    "character": "krillin"
  },
  {
    "number": 173,
    "name": "Vegeta (Lvl 1)",
    "type": "Villain",
    "style": "",
    "level": 1,
    "pur": 2,
    "originalText": "Saiyan Energy Deflection forces only 2 discards form a successful energy attack, no matter how powerful.",
    "effect": "energy-cap",
    "stages": [
      0,
      2000,
      2200,
      2400,
      2600,
      2800,
      3000,
      3200,
      3400,
      3600,
      3800
    ],
    "character": "vegeta"
  },
  {
    "number": 174,
    "name": "Vegeta (Lvl 2)",
    "type": "Villain",
    "style": "",
    "level": 2,
    "pur": 4,
    "originalText": "Saiyan Energy Blast does 3 life card draws of damage and costs only 1 power stage to perform.",
    "effect": "personality",
    "attack": "energy",
    "damage": 3,
    "cost": 1,
    "stages": [
      0,
      4200,
      4700,
      5200,
      5700,
      6200,
      6700,
      7200,
      7700,
      8200,
      8700
    ],
    "character": "vegeta"
  },
  {
    "number": 175,
    "name": "Vegeta (Lvl 3)",
    "type": "Villain",
    "style": "",
    "level": 3,
    "pur": 4,
    "originalText": "Captures one Dragon Ball, once per game, after a successful energy attack. This ends the combat step.",
    "effect": "vegeta-capture",
    "stages": [
      0,
      9000,
      10000,
      11000,
      12000,
      13000,
      14000,
      15000,
      16000,
      17000,
      18000
    ],
    "character": "vegeta"
  },
  {
    "number": 176,
    "name": "Nappa (Lvl 1)",
    "type": "Villain",
    "style": "",
    "level": 1,
    "pur": 2,
    "originalText": "Saiyan Energy Deflection forces only 2 discards from a successful energy attack, no matter how powerful.",
    "effect": "energy-cap",
    "stages": [
      0,
      2000,
      2200,
      2400,
      2600,
      2800,
      3000,
      3200,
      3400,
      3600,
      3800
    ],
    "character": "nappa"
  },
  {
    "number": 177,
    "name": "Nappa (Lvl 2)",
    "type": "Villain",
    "style": "",
    "level": 2,
    "pur": 3,
    "originalText": "Special Physical Attack inflicting 6 stages of power drain, no matter what the foe's power stage rating is.",
    "effect": "personality",
    "attack": "physical",
    "fixedPhysical": 6,
    "damage": 0,
    "stages": [
      0,
      4200,
      4700,
      5200,
      5700,
      6200,
      6700,
      7200,
      7700,
      8200,
      8700
    ],
    "character": "nappa"
  },
  {
    "number": 178,
    "name": "Nappa (Lvl 3)",
    "type": "Villain",
    "style": "",
    "level": 3,
    "pur": 4,
    "originalText": "Only takes 2 stages of power drain, no matter how strong the physical attack.",
    "effect": "physical-cap",
    "stages": [
      0,
      9000,
      9500,
      10000,
      10500,
      11000,
      11500,
      12000,
      12500,
      13000,
      13500
    ],
    "character": "nappa"
  },
  {
    "number": 179,
    "name": "Goku (Lvl 1 HT)",
    "type": "Hero",
    "style": "",
    "level": 1,
    "pur": 1,
    "originalText": "Physical Attack: Do not consult the chart and do 4 stages of damage to the foe.",
    "effect": "personality",
    "attack": "physical",
    "fixedPhysical": 4,
    "damage": 0,
    "stages": [
      0,
      500,
      600,
      700,
      800,
      900,
      1000,
      1100,
      1200,
      1300,
      1400
    ],
    "character": "goku"
  },
  {
    "number": 180,
    "name": "Piccolo (Lvl 1 HT)",
    "type": "Hero",
    "style": "",
    "level": 1,
    "pur": 1,
    "originalText": "When defending in combat, take the bottom discard card as well in your three card draw.",
    "effect": "piccolo-defender-draw",
    "stages": [
      0,
      500,
      600,
      700,
      800,
      900,
      1000,
      1100,
      1200,
      1300,
      1400
    ],
    "character": "piccolo"
  },
  {
    "number": 181,
    "name": "Gohan (Lvl 1 HT)",
    "type": "Hero",
    "style": "",
    "level": 1,
    "pur": 1,
    "originalText": "Energy Attack: Costs 1 stage and does 3 life card draws of damage.",
    "effect": "personality",
    "attack": "energy",
    "damage": 3,
    "cost": 1,
    "stages": [
      0,
      100,
      200,
      300,
      400,
      500,
      600,
      700,
      800,
      900,
      1000
    ],
    "character": "gohan"
  },
  {
    "number": 182,
    "name": "Krillin (Lvl 1 HT)",
    "type": "Hero",
    "style": "",
    "level": 1,
    "pur": 1,
    "originalText": "Draw another card when starting an attack.",
    "effect": "krillin-attacker-draw",
    "stages": [
      0,
      100,
      200,
      300,
      400,
      500,
      600,
      700,
      800,
      900,
      1000
    ],
    "character": "krillin"
  },
  {
    "number": 183,
    "name": "Raditz (Lvl 1 HT)",
    "type": "Villain",
    "style": "",
    "level": 1,
    "pur": 1,
    "originalText": "Raise Raditz' anger level one.",
    "effect": "raditz-anger",
    "stages": [
      0,
      1100,
      1200,
      1300,
      1400,
      1500,
      1600,
      1700,
      1800,
      1900,
      2000
    ],
    "character": "raditz"
  },
  {
    "number": 184,
    "name": "Vegeta (Lvl 1 HT)",
    "type": "Villain",
    "style": "",
    "level": 1,
    "pur": 1,
    "originalText": "Ignore a successful energy attack.",
    "effect": "energy-stop",
    "stages": [
      0,
      2000,
      2200,
      2400,
      2600,
      2800,
      3000,
      3200,
      3400,
      3600,
      3800
    ],
    "character": "vegeta"
  },
  {
    "number": 185,
    "name": "Nappa (Lvl 1 HT)",
    "type": "Villain",
    "style": "",
    "level": 1,
    "pur": 2,
    "originalText": "When starting a battle, power up 2 more stages.",
    "effect": "nappa-attacker-power",
    "stages": [
      0,
      2000,
      2200,
      2400,
      2600,
      2800,
      3000,
      3200,
      3400,
      3600,
      3800
    ],
    "character": "nappa"
  },
  {
    "number": 189,
    "name": "Earth Dragon Ball Combat",
    "type": "Energy Combat",
    "style": "Colorless",
    "originalText": "Energy Attack. After you make a successful energy attack, capture an Earth Dragon Ball from your opponent.",
    "effect": "energy-capture",
    "attack": "energy",
    "damage": 4,
    "cost": 2
  },
  {
    "number": 190,
    "name": "Enraged!",
    "type": "Non-Combat",
    "style": "Colorless",
    "originalText": "Increase your anger level by 2. Select 2 cards from your discard pile and place them at the bottom of your life deck. Discard this card from the game after one use.",
    "effect": "anger-selected-recovery",
    "banish": true,
    "anger": 2
  },
  {
    "number": 191,
    "name": "A Beginners Heart is Dedicated",
    "type": "Non-Combat",
    "style": "Colorless",
    "originalText": "Increase the anger of a level 1 or 2 personality by 1 and discard this card from the game.",
    "effect": "low-level-anger",
    "banish": true
  },
  {
    "number": 192,
    "name": "Teaching the Unteachable Forces Observation",
    "type": "Non-Combat",
    "style": "Colorless",
    "originalText": "Force another player to skip their combat step. Discard this from the game after use.",
    "effect": "skip-opponent-combat",
    "banish": true
  },
  {
    "number": 193,
    "name": "Respect the Spirit",
    "type": "Non-Combat",
    "style": "Colorless",
    "originalText": "The spirit of the Earth heals you. Place 2 discarded cards at the bottom of your life deck. Discard from the game after use.",
    "effect": "selected-recovery",
    "banish": true
  },
  {
    "number": 194,
    "name": "Unselfish Behavior is Best",
    "type": "Non-Combat",
    "style": "Colorless",
    "originalText": "The efforts of your allies stop this combat. You must have an ally out on the table to use this card. Discard from the game after use.",
    "effect": "ally-end-combat",
    "banish": true
  },
  {
    "number": 195,
    "name": "Hero Advantage",
    "type": "Non-Combat",
    "style": "Colorless",
    "originalText": "Allows a hero to draw his cards from the top of the discard deck in the next combat. If there are not enough cards in the discard pile, this card cannot be used. discard from the game after use.",
    "effect": "hero-honor-duel",
    "banish": true
  },
  {
    "number": 196,
    "name": "Saiyan Honor Quest",
    "type": "Non-Combat",
    "style": "Saiyan",
    "originalText": "In the next combat, draw cards from the bottom of the discard pile instead of the Life Deck. Discard after one use.",
    "effect": "honor-quest"
  },
  {
    "number": 197,
    "name": "Saiyan Battle Terms",
    "type": "Non-Combat",
    "style": "Saiyan",
    "originalText": "Remove a Non-Combat Card or ally from in front of another player from the game. Discard this card from the game after use.",
    "effect": "remove-noncombat-ally",
    "banish": true
  },
  {
    "number": 198,
    "name": "Saiyan Appraisal Manuever",
    "type": "Non-Combat",
    "style": "Saiyan",
    "originalText": "Name a Non-Combat card and foes with any in their decks must discard them from the game. Discard this card from the game after use.",
    "effect": "appraisal",
    "banish": true
  },
  {
    "number": 199,
    "name": "Dream Fighting",
    "type": "Combat",
    "style": "Colorless",
    "originalText": "This combat ends and the defender places the bottom discarded card back at the bottom of his life deck. Discard this card from the game after use.",
    "effect": "dream-fighting",
    "banish": true
  },
  {
    "number": 200,
    "name": "Cutting the Tail",
    "type": "Combat",
    "style": "Colorless",
    "originalText": "Reduce the defending main personality's anger level to (0). Discard this card from the game after use.",
    "effect": "defender-anger-zero",
    "banish": true
  },
  {
    "number": 201,
    "name": "The Tail Grows Back",
    "type": "Combat",
    "style": "Colorless",
    "originalText": "Increase the personality's power stage to its maximum level. Discard this card from the game after use.",
    "effect": "combat-full-power",
    "banish": true
  },
  {
    "number": 202,
    "name": "Goku's Lucky Break",
    "type": "Non-Combat",
    "style": "Named",
    "originalText": "Draw an unused Dragon Ball from your life deck and place it down. Shuffle the life deck afterwards.",
    "effect": "search-ball-shuffle"
  },
  {
    "number": 203,
    "name": "Saiyan Truce Card",
    "type": "Combat",
    "style": "Saiyan",
    "originalText": "Stops this combat. The turn ends, and the user may hold all his extra cards until his next turn. Discard from the game after use.",
    "effect": "truce-keep-hand",
    "banish": true
  },
  {
    "number": 204,
    "name": "Battle Pausing",
    "type": "Combat",
    "style": "Colorless",
    "originalText": "The attacker draws 2 cards from his discard pile. The defender raises 5 stages if possible.",
    "effect": "battle-pausing"
  },
  {
    "number": 205,
    "name": "Grabbing the Tail",
    "type": "Combat",
    "style": "Colorless",
    "originalText": "Reduce the foe's power level by 4 stages, or to (0), whichever happens first. Discard this card from the game after use.",
    "effect": "opponent-power-drain",
    "banish": true
  },
  {
    "number": 206,
    "name": "Nappa's Blinding Stare",
    "type": "Combat",
    "style": "Named",
    "originalText": "The attacker is temporarily blinded and this combat stops. Discard this card from the game after use.",
    "effect": "end-combat",
    "banish": true
  },
  {
    "number": 207,
    "name": "Power Gifting",
    "type": "Non-Combat",
    "style": "Colorless",
    "originalText": "One ally gives your main personality power on a stage for stage basis, reducing their total and boosting your main personality's. Discard from the game after use.",
    "effect": "ally-power-transfer",
    "banish": true
  },
  {
    "number": 208,
    "name": "Terrible Wounds",
    "type": "Non-Combat",
    "style": "Colorless",
    "originalText": "Place this on a foe's personality card. Reset the personality's anger to (0). It cannot go up until after he forces another player to discard a life card. Discard this from the game after use. Limit 1 per deck.",
    "effect": "anger-lock",
    "printedLimit": 1,
    "banish": true
  },
  {
    "number": 209,
    "name": "Broken Scouter",
    "type": "Non-Combat",
    "style": "Colorless",
    "originalText": "Your power level was miscounted. Raise it to full power. Discard this from the game after use.",
    "effect": "full-power",
    "banish": true
  },
  {
    "number": 210,
    "name": "Raditz Flying Kick",
    "type": "Physical Combat",
    "style": "Named",
    "originalText": "Physical attack doing triple the usual damage if successful.",
    "effect": "physical-triple",
    "attack": "physical",
    "damage": 0
  },
  {
    "number": 211,
    "name": "Tien Mind Reading Trick",
    "type": "Non-Combat",
    "style": "Named",
    "originalText": "This card stays on the table. If Tien is in play, all villains must show their hands face up at all times.",
    "effect": "tien-reveal-hands"
  },
  {
    "number": 212,
    "name": "Piccolo's Flight",
    "type": "Non-Combat",
    "style": "Named",
    "originalText": "Stops a successful physical or energy attack.",
    "effect": "setup-block"
  },
  {
    "number": 213,
    "name": "Plant Two Saibaimen",
    "type": "Non-Combat",
    "style": "Colorless",
    "originalText": "A villain may plant this card instead of combat. On his next turn, he takes his highest level Saibaimen and puts it into play as an ally. Discard this card from the game after use.",
    "effect": "plant-saibaimen",
    "banish": true
  },
  {
    "number": 214,
    "name": "Gohan's Father Save",
    "type": "Combat",
    "style": "Named",
    "originalText": "If Gohan is Goku's ally, he stops the foe's combat turn. Discard after use.",
    "effect": "gohan-save"
  },
  {
    "number": 215,
    "name": "Krillin's Drill",
    "type": "Non-Combat",
    "style": "Named",
    "originalText": "Does an extra life card of damage with each successful attack. More than 1 of these drills can be out at the same time.",
    "effect": "life-bonus-drill",
    "damage": 1
  },
  {
    "number": 217,
    "name": "Ribs Broken",
    "type": "Energy Combat",
    "style": "Colorless",
    "originalText": "Discard an ally from the game to make an energy attack. The foe takes 5 life cards of damage.",
    "effect": "ally-sacrifice-attack",
    "attack": "energy",
    "damage": 5,
    "cost": 2
  },
  {
    "number": 218,
    "name": "Unexpected Allies",
    "type": "Combat",
    "style": "Colorless",
    "originalText": "Pull an ally card from the discards or the life deck, play it and set its power stages at full.",
    "effect": "search-ally"
  },
  {
    "number": 220,
    "name": "Vegeta's Stance",
    "type": "Energy Combat",
    "style": "Named",
    "originalText": "Prevents all but 1 life card draw from a successful energy attack. Discard from the game after use.",
    "effect": "energy-cap-one",
    "defense": "energy",
    "banish": true
  },
  {
    "number": 221,
    "name": "Vegeta's Quickness Drill",
    "type": "Non-Combat",
    "style": "Named",
    "originalText": "At the beginning of each combat, draw 1 card from the bottom of the discard pile to use.",
    "effect": "combat-discard-draw"
  },
  {
    "number": 222,
    "name": "Bulma Finds a Dragon Ball",
    "type": "Non-Combat",
    "style": "Named",
    "originalText": "When the Bulma ally is in play, use this card to capture a Dragon Ball. Discard from the game after use.",
    "effect": "bulma-capture",
    "banish": true
  },
  {
    "number": 223,
    "name": "Bulma Finds a Drill",
    "type": "Non-Combat",
    "style": "Named",
    "originalText": "When the Bulma ally is in play, pick a drill from the life deck or the discards and put it into play.",
    "effect": "bulma-search-drill"
  },
  {
    "number": 224,
    "name": "Baba Witch Viewing Drill",
    "type": "Non-Combat",
    "style": "Named",
    "originalText": "Forces every Villain opponent to constantly show his hand of cards face up at all times.",
    "effect": "reveal-hands-drill"
  },
  {
    "number": 225,
    "name": "Baba's Energy Blast",
    "type": "Non-Combat",
    "style": "Named",
    "originalText": "Does 3 life card discards in damage at any time to a foe. Discard this card from the game after 1 use.",
    "effect": "direct-life-damage",
    "banish": true
  },
  {
    "number": 226,
    "name": "T-Rex Defense",
    "type": "Non-Combat",
    "style": "Colorless",
    "originalText": "The beast takes all damage from physical atacks for the card user, but the first energy attack kills it. Discard from the game after 1 use.",
    "effect": "trex-defense"
  },
  {
    "number": 227,
    "name": "T-Rex Offense",
    "type": "Non-Combat",
    "style": "Colorless",
    "originalText": "In every battle where the card owner is attacking, it does 1 life card in damage per combat until an energy attack kills it.",
    "effect": "trex-offense"
  },
  {
    "number": 228,
    "name": "Vegeta's Plans",
    "type": "Non-Combat",
    "style": "Named",
    "originalText": "Get a Dragon Ball card from the life deck and put it into play. Remove from game after one use.",
    "effect": "search-ball",
    "banish": true
  },
  {
    "number": 229,
    "name": "Ally Wins!",
    "type": "Non-Combat",
    "style": "Colorless",
    "originalText": "This card does 1 life card in damage to a foe for every ally the card user has. Discard from the game after use.",
    "effect": "ally-count-damage",
    "banish": true
  },
  {
    "number": 230,
    "name": "Chiaotzu's Drill",
    "type": "Non-Combat",
    "style": "Named",
    "originalText": "Allows the user to duck and miss the first stage of damage in a physical attack.",
    "effect": "physical-reduction-drill",
    "damage": 1
  },
  {
    "number": 231,
    "name": "Goku's Mixing Drill",
    "type": "Non-Combat",
    "style": "Named",
    "originalText": "Allows multiple colors of drills to be used at the same time.",
    "effect": "mixing-drill"
  },
  {
    "number": 232,
    "name": "Red Life Attack Drill",
    "type": "Non-Combat",
    "style": "Red",
    "originalText": "Drill does an extra life card of damage whenever successful damage is done.",
    "effect": "life-bonus-drill",
    "damage": 1
  },
  {
    "number": 233,
    "name": "Blue Life Defense Drill",
    "type": "Non-Combat",
    "style": "Blue",
    "originalText": "Drill prevents 1 life card of damage from being taken whenever a successful attack happens on the card owner.",
    "effect": "life-reduction-drill",
    "damage": 1
  },
  {
    "number": 234,
    "name": "Orange Focusing Drill",
    "type": "Non-Combat",
    "style": "Orange",
    "originalText": "Prevents anything from happening to a personality's drills until he advances to his next level.",
    "effect": "protect-drills"
  },
  {
    "number": 235,
    "name": "Black Shadow Drill",
    "type": "Non-Combat",
    "style": "Black",
    "originalText": "Allows the card owner to take 2 less stages of power drain from a successful physical attack.",
    "effect": "physical-reduction-drill",
    "damage": 2
  },
  {
    "number": 237,
    "name": "Goku's Capturing Drill",
    "type": "Non-Combat",
    "style": "Named",
    "originalText": "Prevents any Dragon Ball from being captured from this drill user.",
    "effect": "protect-balls"
  },
  {
    "number": 238,
    "name": "King Kai's Calming",
    "type": "Non-Combat",
    "style": "Named",
    "originalText": "Played at the end of a turn, it forces a foe back from level 3 to level 2. Limit 1 per deck.",
    "effect": "calming-three",
    "printedLimit": 1
  },
  {
    "number": 239,
    "name": "Roshi's Calming",
    "type": "Non-Combat",
    "style": "Named",
    "originalText": "Played at the end of a turn, it forces a foe back from level 2 to level 1. Limit 1 per deck.",
    "effect": "calming-two",
    "printedLimit": 1
  },
  {
    "number": 240,
    "name": "Vegeta's Trick",
    "type": "Non-Combat",
    "style": "Named",
    "originalText": " Find the foe's first Dragon Ball in his life deck and place it at the bottom of his deck. Limit 1 per deck.",
    "effect": "bury-hidden-ball",
    "printedLimit": 1
  },
  {
    "number": 241,
    "name": "Vegeta's Dragonball Capture",
    "type": "Non-Combat",
    "style": "Named",
    "originalText": "Capture 2 of a foe's Dragon Balls and place them at the bottom of his life deck. Limit 1 per deck.",
    "effect": "bury-two-balls",
    "printedLimit": 1
  },
  {
    "number": 242,
    "name": "Dream Machine Battle",
    "type": "Combat",
    "style": "Colorless",
    "originalText": "This battle never happened. Start all over with new cards and reset all damage to beginning levels. Limit 1 per deck.",
    "effect": "reset-battle",
    "printedLimit": 1
  },
  {
    "number": 244,
    "name": "Saibaimen (Lvl 2)",
    "type": "Villain",
    "style": "",
    "level": 2,
    "pur": 2,
    "originalText": "Saiyan Energy Deflection forces only two discards from a successful energy attack, no matter how powerful.",
    "effect": "energy-cap",
    "stages": [
      0,
      2000,
      2200,
      2400,
      2600,
      2800,
      3000,
      3200,
      3400,
      3600,
      3800
    ],
    "character": "saibaimen"
  },
  {
    "number": 245,
    "name": "Saibaimen (Lvl 3)",
    "type": "Villain",
    "style": "",
    "level": 3,
    "pur": 3,
    "originalText": "Saiyan Energy Deflection forces only two discards from a successful energy attack, no matter how powerful.",
    "effect": "energy-cap",
    "stages": [
      0,
      4200,
      4700,
      5200,
      5700,
      6200,
      6700,
      7200,
      7700,
      8200,
      8700
    ],
    "character": "saibaimen"
  },
  {
    "number": 246,
    "name": "Saibaimen (Lvl 4)",
    "type": "Villain",
    "style": "",
    "level": 4,
    "pur": 4,
    "originalText": "If there is more than one Saibaimen in play, this one can make a physical attack that inflicts 5 life cards damage.",
    "effect": "saibaimen-physical-life",
    "attack": "physical",
    "damage": 5,
    "stages": [
      0,
      9000,
      10000,
      11000,
      12000,
      13000,
      14000,
      15000,
      16000,
      17000,
      18000
    ],
    "character": "saibaimen"
  },
  {
    "number": 247,
    "name": "Goku's Truce",
    "type": "Combat",
    "style": "Named",
    "originalText": "Stops a successful energy or physical attack.",
    "effect": "defense",
    "defense": "both"
  },
  {
    "number": 248,
    "name": "Goku's Plan",
    "type": "Energy Combat",
    "style": "Named",
    "originalText": "Energy attack doing 5 life cards of damage for no power cost.",
    "effect": "attack",
    "attack": "energy",
    "damage": 5,
    "cost": 0
  },
  {
    "number": 249,
    "name": "Medic Kit",
    "type": "Non-Combat",
    "style": "Colorless",
    "originalText": "Place the top 3 discard cards at the bottom of the life card deck. Limit 1 per deck.",
    "effect": "top-three-recovery",
    "printedLimit": 1
  },
  {
    "number": 250,
    "name": "Chiaotzu's Physical Defense",
    "type": "Combat",
    "style": "Named",
    "originalText": "Stops all heroes from losing 1 life card for this entire combat. Multiples of this card cannot be used together. Remove from the game after use.",
    "effect": "hero-life-shield",
    "banish": true
  }
];
